// import React from 'react';
// import AddProductWizard from '../components/AddProduct/AddProductWizard';

// const AddProductPage = () => {
//   return <AddProductWizard />;
// };

// export default AddProductPage;

import React from "react";
import AddProduct from "../components/AddProduct/AddProduct";

const AddProductPage = () => {
  return <AddProduct />;
};

export default AddProductPage;
